import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function stopTinkerBox(fetch: Fetch, id: number) {
  return fetch(
    `/tinker-boxes/${id}/stop`,
    { method: 'POST' },
    schemas.SuccessDto
  );
}

export const useStopTinkerBoxMutation = () => {
  return useMutation({
    mutationKey: ['stopTinkerBox'],
    mutationFn: (id: number) => stopTinkerBox(fetch, id)
  });
};
